<template>
  <div class="row m-0 mb-4">
    <div class="pl-0 column">
      <div class="person-card">
          <h5 class="card-title">{{ $t('checkup_plus.reports.patient_details.individual_report_title') }}</h5>
          <p class="card-description"> This report presents the results of Evollu Check-Up Plus Consultation</p>
          <p class="card-text-bold mb-0"> {{ $t('checkup_plus.reports.patient_details.consultation_date') }}</p>
          <p class="card-text-normal"> {{ data.date }}</p>
      </div>
    </div>
    <div class="column">
      <div class="person-card">
          <h5 class="card-title">{{ $t('checkup_plus.reports.patient_details.patient_details') }}</h5>
          <p class="card-text-normal"> {{ data.patientName }}</p>
          <table>
            <tr>
              <td>
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.gender')}} </span>
              </td>
              <td>
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.nationality')}} </span>
              </td>
              <td>
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.birthdate')}} </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="card-text-normal"> {{ $t(`genders.${data.gender.toLowerCase()}`) }} </span>
              </td>
              <td>
                <span class="card-text-normal"> {{data.nationality}} </span>
              </td>
              <td>
                <span class="card-text-normal"> {{ data.birthdate }} </span>
              </td>
            </tr>
            <tr>
              <td class="pt-3">
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.address')}} </span>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <span class="card-text-normal"> {{ data.address }} </span>
              </td>
            </tr>

          </table>
      </div>
    </div>
    <div class="pr-0 column">
      <div class="person-card">
          <h5 class="card-title">{{ $t('checkup_plus.reports.patient_details.location_details') }}</h5>
          <table>
            <tr>
              <td>
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.facility')}} </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="card-text-normal"> {{ data.facility }} </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="card-text-bold"> {{$t('checkup_plus.reports.patient_details.entity')}} </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="card-text-normal"> {{ data.entity }} </span>
              </td>
            </tr>
          </table>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PatientDetails",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.column {
  width: 30%;
  float: left;
}
.column:nth-child(2) {
  width: 40%;
}

.column:not(:first-child) {
  padding-left: 12px;
}


.row:after {
  content: "";
  display: table;
  clear: both;
}

.person-card {
  height: 100%;
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}






table td:not(:first-child) {
  padding-left: 12px;
}
</style>
